import { STATIC_EXPERIMENT_CONFIG } from '../experiments';
import {
  getTreatmentCountForPath,
  isBinaryExperiment,
  isMultiVariateExperiment,
} from '../experiments/isMultiVariateExperiment';
import { STATIC_EXPERIMENT_MULTI_TREATMENTS } from '../experiments/variantConfig';
import type { SupportedExperimentVariants } from './types';

type StaticExperimentMultiTreatment = (typeof STATIC_EXPERIMENT_MULTI_TREATMENTS)[number];

export const isStaticExperiment = (experimentName: string) => {
  return Object.values(STATIC_EXPERIMENT_CONFIG).includes(experimentName);
};

/**
 * When just checking if a static experiment is active and don't care
 * if it is control or the variant(s)
 */
export function isStaticExperimentActive(experimentId: string, path: string) {
  return STATIC_EXPERIMENT_CONFIG[path] === experimentId;
}

export function isStaticExperimentEnabled(
  experimentId: string,
  path: string,
  experimentDecision: SupportedExperimentVariants,
) {
  if (!isStaticExperimentActive(experimentId, path)) {
    return false;
  }

  if (isMultiVariateExperiment(path)) {
    const activeTreatments = STATIC_EXPERIMENT_MULTI_TREATMENTS.slice(
      0,
      getTreatmentCountForPath(path),
    );
    return activeTreatments.includes(experimentDecision as StaticExperimentMultiTreatment);
  }

  if (isBinaryExperiment(path)) {
    return experimentDecision === 'treatment';
  }

  return false;
}
